module.exports = __webpack_public_path__ + "img/swiper_bg1.f354b40d.png";